<p>classroom-snapshot works!</p>
